import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AriaLabels, Tab, TabClickEvent } from '@maced/angular-components/lib/tab/tab.interface';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent {
  tabItems: Tab[] = [];
  tabItemsForTab: Tab[] = [];
  activeTab: string = "";
  show = true;
  sliderBtns: boolean = true;
  isBrowser: any;
  isServer: any;
  ariaLabels: AriaLabels;
  padding = false;
  queryParams = { 'name': 'test' };
  tabItemsGray:Tab[] = [];
  tabItemsForTabGray:  Tab[] = []
  tabItemsForSwipe:Tab[] = [];
  simplifiedTabItems:Tab[] = [];
  simplifiedTabItemsWithoutSwipe:Tab[] = [];
  hierarchyTabLevels: Tab[] = [
    {
      id: 'hierarchy-area-tab',
      name: 'AreasOfLearning',
      label: 'Areas of learning',
      targetUrl: '',
      tabContentData: 'Areas of learning bar chart',
      tabContentId: 'AreasOfLearningPanel',
      isActive: true,
      isDisabled: false
    },
    {
      id: 'hierarchy-pronunciation-tab',
      name: 'Pronunciation',
      label: 'Pronunciation',
      targetUrl: '',
      tabContentData: 'Pronunciation bar chart',
      tabContentId: 'PronunciationPanel',
      isActive: false,
      isDisabled: false
    },
    {
      id: 'hierarchy-phonetics-tab',
      name: 'Phonetics',
      label: 'Phonetics',
      targetUrl: '',
      tabContentData: 'Phonetics bar chart',
      tabContentId: 'PhoneticsPanel',
      isActive: false,
      isDisabled: false
    },
    {
      id: 'hierarchy-segmental-features-tab',
      name: 'SegmentalFeatures',
      label: 'Segmental features',
      targetUrl: '',
      tabContentData: 'Segmental features bar chart',
      tabContentId: 'SegmentalFeaturesPanel',
      isActive: false,
      isDisabled: false
    },
    {
      id: 'hierarchy-consonants-tab',
      name: 'Consonants',
      label: 'Consonants',
      targetUrl: '',
      tabContentData: 'Consonants bar chart',
      tabContentId: 'ConsonantsPanel',
      isActive: false,
      isDisabled: false
    },
    {
      id: 'hierarchy-fricatives-tab',
      name: 'Fricatives',
      label: 'Fricatives',
      targetUrl: '',
      tabContentData: 'Fricatives bar chart',
      tabContentId: 'FricativesPanel',
      isActive: false,
      isDisabled: false
    },
    {
      id: 'hierarchy-labiodental-fricatives-tab',
      name: 'LabiodentalFricatives',
      label: 'Labiodental fricatives',
      targetUrl: '',
      tabContentData: 'Labiodental fricatives bar chart',
      tabContentId: 'LabiodentalFricativesPanel',
      isActive: false,
      isDisabled: false
    },
    {
      id: 'hierarchy-voiceless-fricative-tab',
      name: 'VoicelessFricative',
      label: 'Voiceless fricative',
      targetUrl: '',
      tabContentData: 'Voiceless fricative bar chart',
      tabContentId: 'VoicelessFricativePanel',
      isActive: false,
      isDisabled: false
    },
    {
      id: 'hierarchy-initial-sound-tab',
      name: 'InitialSound',
      label: 'Initial sound',
      targetUrl: '',
      tabContentData: 'Initial sound bar chart',
      tabContentId: 'InitialSoundPanel',
      isActive: false,
      isDisabled: false
    }
  ];
  hierarchyTabItems: Tab[] = [{ ...this.hierarchyTabLevels[0] }];
  activeHierarchyTab = this.hierarchyTabLevels[0].tabContentId;
  constructor(
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.isServer = isPlatformServer(platformId);

    this.ariaLabels = {
      previousButton: "Previous",
      nextButton: "Next"
    }

    this.tabItems = [
      {
        id: "nav1-tab",
        name: "Tab1",
        tabContentData: "Tab content data for Tab1",
        label: "Tab 1",
        targetUrl: "/tab",
        tabContentId: "content1",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1',
        subTitle: 'Label2',
        badgeId: 'badge1',
        badgeLabel: 100,
        badgeSize: 'small'
      },
      {
        id: "nav2-tab",
        name: "Tab2",
        tabContentData: "Tab content data for Tab2",
        label: "Tab 2",
        targetUrl: "/tab",
        tabContentId: "content2",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1',
        subTitle: 'Label2'
      },
      {
        id: "nav3-tab",
        name: "Tab3",
        tabContentData: "Tab content data for Tab3",
        label: "Tab 3",
        targetUrl: "/tab",
        tabContentId: "content3",
        isActive: false,
        isDisabled: true
      },
      {
        id: "nav4-tab",
        name: "Tab4",
        tabContentData: "Tab content data for Tab4",
        label: "Tab 4",
        targetUrl: "/tab",
        tabContentId: "content4",
        isActive: false,
        isDisabled: false,
        title: 'Label1',
        subTitle: 'Label2',
        badgeId: 'badge2',
        badgeLabel: 90,
        badgeSize: 'small'
      },
      {
        id: "nav5-tab",
        name: "Tab5",
        tabContentData: "Tab content data for Tab5",
        label: "Tab 5",
        targetUrl: "/tab",
        tabContentId: "Tab5",
        isActive: false,
        isDisabled: false,
        title: 'Label1',
        badgeId: 'badge3',
        badgeLabel: 100,
        badgeSize: 'small'
      },
      {
        id: "nav6-tab",
        name: "Tab6",
        tabContentData: "Tab content data for Tab6",
        label: "Tab 6",
        targetUrl: "/tab",
        tabContentId: "Tab6",
        isActive: false,
        isDisabled: false,
        icon: 'icon-minus-circle',
        badgeId: 'badge4',
        badgeLabel: 100,
        badgeSize: 'small'
      },
      {
        id: "nav7-tab",
        name: "Tab7",
        tabContentData: "Tab content data for Tab7",
        label: "Tab 7",
        targetUrl: "/tab",
        tabContentId: "Tab7",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav8-tab",
        name: "Tab8",
        tabContentData: "Tab content data for Tab8",
        label: "Tab 8",
        targetUrl: "/tab",
        tabContentId: "Tab8",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav9-tab",
        name: "Tab9",
        tabContentData: "Tab content data for Tab9",
        label: "Tab 9",
        targetUrl: "/tab",
        tabContentId: "Tab9",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav10-tab",
        name: "Tab10",
        tabContentData: "Tab content data for Tab10",
        label: "Tab 10",
        targetUrl: "/tab",
        tabContentId: "Tab10",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav11-tab",
        name: "Tab11",
        tabContentData: "Tab content data for Tab11",
        label: "Tab 11",
        targetUrl: "/tab",
        tabContentId: "Tab11",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav12-tab",
        name: "Tab12",
        tabContentData: "Tab content data for Tab12",
        label: "Tab 12",
        targetUrl: "/tab",
        tabContentId: "Tab12",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav13-tab",
        name: "Tab13",
        tabContentData: "Tab content data for Tab13",
        label: "Tab 13",
        targetUrl: "/tab",
        tabContentId: "Tab13",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav14-tab",
        name: "Tab14",
        tabContentData: "Tab content data for Tab14",
        label: "Tab 14",
        targetUrl: "/tab",
        tabContentId: "Tab14",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav15-tab",
        name: "Tab15",
        tabContentData: "Tab content data for Tab15",
        label: "Tab 15",
        targetUrl: "/tab",
        tabContentId: "Tab15",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav16-tab",
        name: "Tab16",
        tabContentData: "Tab content data for Tab16",
        label: "Tab 16",
        targetUrl: "/tab",
        tabContentId: "Tab16",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav17-tab",
        name: "Tab17",
        tabContentData: "Tab content data for Tab17",
        label: "Tab 17",
        targetUrl: "/tab",
        tabContentId: "Tab17",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav18-tab",
        name: "Tab18",
        tabContentData: "Tab content data for Tab18",
        label: "Tab 18",
        targetUrl: "/tab",
        tabContentId: "Tab18",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav19-tab",
        name: "Tab19",
        tabContentData: "Tab content data for Tab19",
        label: "Tab 19",
        targetUrl: "/tab",
        tabContentId: "Tab19",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav20-tab",
        name: "Tab20",
        tabContentData: "Tab content data for Tab20",
        label: "Tab 20",
        targetUrl: "/tab",
        tabContentId: "Tab20",
        isActive: false,
        isDisabled: false
      }
    ];

    this.tabItemsForTab = [
      {
        id: "nav21-tab",
        name: "Tab1",
        tabContentData: "Tab content data for Tab1",
        label: "Tab 1",
        targetUrl: "/tab",
        tabContentId: "Tab21",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1',
        subTitle: 'Label2',
        badgeId: 'badge21',
        badgeLabel: 100,
        badgeSize: 'small'
      },
      {
        id: "nav22-tab",
        name: "Tab2",
        tabContentData: "Tab content data for Tab2",
        label: "Tab 2",
        targetUrl: "/tab",
        tabContentId: "Tab22",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1',
        subTitle: 'Label2'
      },
      {
        id: "nav23-tab",
        name: "Tab3",
        tabContentData: "Tab content data for Tab3",
        label: "Tab 3",
        targetUrl: "/tab",
        tabContentId: "Tab23",
        isActive: false,
        isDisabled: true
      },
      {
        id: "nav24-tab",
        name: "Tab4",
        tabContentData: "Tab content data for Tab4",
        label: "Tab 4",
        targetUrl: "/tab",
        tabContentId: "Tab24",
        isActive: false,
        isDisabled: false,
        title: 'Label1',
        subTitle: 'Label2',
        badgeId: 'badge22',
        badgeLabel: 90,
        badgeSize: 'small'
      },
      {
        id: "nav25-tab",
        name: "Tab5",
        tabContentData: "Tab content data for Tab5",
        label: "Tab 5",
        targetUrl: "/tab",
        tabContentId: "Tab25",
        isActive: false,
        isDisabled: false,
        icon: 'icon-minus-circle',
        title: 'Label1',
        badgeId: 'badge23',
        badgeLabel: 100,
        badgeSize: 'small'
      }
    ];

    this.tabItemsGray = [
      {
        id: "nav31-tab",
        name: "Tab1",
        tabContentData: "Tab content data for Tab1",
        label: "Tab 1",
        targetUrl: "/tab",
        tabContentId: "Tab31",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1',
        subTitle: 'Label2',
        badgeId: 'badge31',
        badgeLabel: 100,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav32-tab",
        name: "Tab2",
        tabContentData: "Tab content data for Tab2",
        label: "Tab 2",
        targetUrl: "/tab",
        tabContentId: "Tab32",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1',
        subTitle: 'Label2'
      },
      {
        id: "nav33-tab",
        name: "Tab3",
        tabContentData: "Tab content data for Tab3",
        label: "Tab 3",
        targetUrl: "/tab",
        tabContentId: "Tab33",
        isActive: false,
        isDisabled: true
      },
      {
        id: "nav34-tab",
        name: "Tab4",
        tabContentData: "Tab content data for Tab4",
        label: "Tab 4",
        targetUrl: "/tab",
        tabContentId: "Tab34",
        isActive: false,
        isDisabled: false,
        title: 'Label1',
        subTitle: 'Label2',
        badgeId: 'badge32',
        badgeLabel: 90,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav35-tab",
        name: "Tab5",
        tabContentData: "Tab content data for Tab5",
        label: "Tab 5",
        targetUrl: "/tab",
        tabContentId: "Tab35",
        isActive: false,
        isDisabled: false,
        title: 'Label1',
        badgeId: 'badge33',
        badgeLabel: 100,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav36-tab",
        name: "Tab6",
        tabContentData: "Tab content data for Tab6",
        label: "Tab 6",
        targetUrl: "/tab",
        tabContentId: "Tab36",
        isActive: false,
        isDisabled: false,
        icon: 'icon-minus-circle',
        badgeId: 'badge34',
        badgeLabel: 100,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav37-tab",
        name: "Tab7",
        tabContentData: "Tab content data for Tab7",
        label: "Tab 7",
        targetUrl: "/tab",
        tabContentId: "Tab37",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav38-tab",
        name: "Tab8",
        tabContentData: "Tab content data for Tab8",
        label: "Tab 8",
        targetUrl: "/tab",
        tabContentId: "Tab38",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav39-tab",
        name: "Tab9",
        tabContentData: "Tab content data for Tab9",
        label: "Tab 9",
        targetUrl: "/tab",
        tabContentId: "Tab39",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav310-tab",
        name: "Tab10",
        tabContentData: "Tab content data for Tab10",
        label: "Tab 10",
        targetUrl: "/tab",
        tabContentId: "Tab310",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav311-tab",
        name: "Tab11",
        tabContentData: "Tab content data for Tab11",
        label: "Tab 11",
        targetUrl: "/tab",
        tabContentId: "Tab311",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav312-tab",
        name: "Tab12",
        tabContentData: "Tab content data for Tab12",
        label: "Tab 12",
        targetUrl: "/tab",
        tabContentId: "Tab312",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav313-tab",
        name: "Tab13",
        tabContentData: "Tab content data for Tab13",
        label: "Tab 13",
        targetUrl: "/tab",
        tabContentId: "Tab313",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav314-tab",
        name: "Tab14",
        tabContentData: "Tab content data for Tab14",
        label: "Tab 14",
        targetUrl: "/tab",
        tabContentId: "Tab314",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav315-tab",
        name: "Tab15",
        tabContentData: "Tab content data for Tab15",
        label: "Tab 15",
        targetUrl: "/tab",
        tabContentId: "Tab315",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav316-tab",
        name: "Tab16",
        tabContentData: "Tab content data for Tab16",
        label: "Tab 16",
        targetUrl: "/tab",
        tabContentId: "Tab316",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav317-tab",
        name: "Tab17",
        tabContentData: "Tab content data for Tab17",
        label: "Tab 17",
        targetUrl: "/tab",
        tabContentId: "Tab317",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav318-tab",
        name: "Tab18",
        tabContentData: "Tab content data for Tab18",
        label: "Tab 18",
        targetUrl: "/tab",
        tabContentId: "Tab318",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav319-tab",
        name: "Tab19",
        tabContentData: "Tab content data for Tab19",
        label: "Tab 19",
        targetUrl: "/tab",
        tabContentId: "Tab319",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav320-tab",
        name: "Tab20",
        tabContentData: "Tab content data for Tab20",
        label: "Tab 20",
        targetUrl: "/tab",
        tabContentId: "Tab320",
        isActive: false,
        isDisabled: false
      }
    ];

    this.tabItemsForTabGray = [
      {
        id: "nav41-tab",
        name: "Tab1",
        tabContentData: "Tab content data for Tab1",
        label: "Tab 1",
        targetUrl: "/tab",
        tabContentId: "Tab41",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1',
        badgeId: 'badge41',
        badgeLabel: 100,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav42-tab",
        name: "Tab2",
        tabContentData: "Tab content data for Tab2",
        label: "Tab 2",
        targetUrl: "/tab",
        tabContentId: "Tab42",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1'
      },
      {
        id: "nav43-tab",
        name: "Tab3",
        tabContentData: "Tab content data for Tab3",
        label: "Tab 3",
        targetUrl: "/tab",
        tabContentId: "Tab43",
        isActive: false,
        isDisabled: true
      },
      {
        id: "nav44-tab",
        name: "Tab4",
        tabContentData: "Tab content data for Tab4",
        label: "Tab 4",
        targetUrl: "/tab",
        tabContentId: "Tab44",
        isActive: false,
        isDisabled: false,
        title: 'Label1',
        subTitle: 'Label2',
        badgeId: 'badge42',
        badgeLabel: 90,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav45-tab",
        name: "Tab5",
        tabContentData: "Tab content data for Tab5",
        label: "Tab 5",
        targetUrl: "/tab",
        tabContentId: "Tab45",
        isActive: false,
        isDisabled: false,
        icon: 'icon-minus-circle',
        title: 'Label1',
        badgeId: 'badge43',
        badgeLabel: 100,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav46-tab",
        name: "Tab6",
        tabContentData: "Tab content data for Tab6",
        label: "Tab 6",
        targetUrl: "/tab",
        tabContentId: "Tab46",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav47-tab",
        name: "Tab7",
        tabContentData: "Tab content data for Tab7",
        label: "Tab 7",
        targetUrl: "/tab",
        tabContentId: "Tab47",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav48-tab",
        name: "Tab8",
        tabContentData: "Tab content data for Tab8",
        label: "Tab 8",
        targetUrl: "/tab",
        tabContentId: "Tab48",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav49-tab",
        name: "Tab9",
        tabContentData: "Tab content data for Tab9",
        label: "Tab 9",
        targetUrl: "/tab",
        tabContentId: "Tab49",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav410-tab",
        name: "Tab10",
        tabContentData: "Tab content data for Tab10",
        label: "Tab 10",
        targetUrl: "/tab",
        tabContentId: "Tab410",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav411-tab",
        name: "Tab11",
        tabContentData: "Tab content data for Tab11",
        label: "Tab 11",
        targetUrl: "/tab",
        tabContentId: "Tab411",
        isActive: false,
        isDisabled: false
      }
    ];

    this.tabItemsForSwipe = [
      {
        id: "nav51-tab",
        name: "Tab1",
        tabContentData: "Tab content data for Tab1",
        label: "Tab 1",
        targetUrl: "/tab",
        tabContentId: "Tab51",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1',
        badgeId: 'badge51',
        badgeLabel: 100,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav52-tab",
        name: "Tab2",
        tabContentData: "Tab content data for Tab2",
        label: "Tab 2",
        targetUrl: "/tab",
        tabContentId: "Tab52",
        isActive: false,
        isDisabled: false,
        icon: 'icon-plus-circle',
        title: 'Label1'
      },
      {
        id: "nav53-tab",
        name: "Tab3",
        tabContentData: "Tab content data for Tab3",
        label: "Tab 3",
        targetUrl: "/tab",
        tabContentId: "Tab53",
        isActive: false,
        isDisabled: true
      },
      {
        id: "nav54-tab",
        name: "Tab4",
        tabContentData: "Tab content data for Tab4",
        label: "Tab 4",
        targetUrl: "/tab",
        tabContentId: "Tab54",
        isActive: false,
        isDisabled: false,
        title: 'Label1',
        subTitle: 'Label2',
        badgeId: 'badge52',
        badgeLabel: 90,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav55-tab",
        name: "Tab5",
        tabContentData: "Tab content data for Tab5",
        label: "Tab 5",
        targetUrl: "/tab",
        tabContentId: "Tab55",
        isActive: false,
        isDisabled: false,
        icon: 'icon-minus-circle',
        title: 'Label1',
        badgeId: 'badge53',
        badgeLabel: 100,
        badgeSize: 'small',
        badgeColor: 'gray'
      },
      {
        id: "nav56-tab",
        name: "Tab6",
        tabContentData: "Tab content data for Tab6",
        label: "Tab 6",
        targetUrl: "/tab",
        tabContentId: "Tab56",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav57-tab",
        name: "Tab7",
        tabContentData: "Tab content data for Tab7",
        label: "Tab 7",
        targetUrl: "/tab",
        tabContentId: "Tab57",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav58-tab",
        name: "Tab8",
        tabContentData: "Tab content data for Tab8",
        label: "Tab 8",
        targetUrl: "/tab",
        tabContentId: "Tab58",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav59-tab",
        name: "Tab9",
        tabContentData: "Tab content data for Tab9",
        label: "Tab 9",
        targetUrl: "/tab",
        tabContentId: "Tab59",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav60-tab",
        name: "Tab10",
        tabContentData: "Tab content data for Tab10",
        label: "Tab 10",
        targetUrl: "/tab",
        tabContentId: "Tab460",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav461-tab",
        name: "Tab11",
        tabContentData: "Tab content data for Tab11",
        label: "Tab 11",
        targetUrl: "/tab",
        tabContentId: "Tab61",
        isActive: false,
        isDisabled: false
      }
    ];
    this.simplifiedTabItems = [
      {
        id: "nav61-tab",
        name: "Tab61",
        tabContentData: "Tab content data for Tab1",
        label: "Tab 1",
        targetUrl: "/pageHeader",
        tabContentId: "Tab61",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav62-tab",
        name: "Tab62",
        tabContentData: "Tab content data for Tab2",
        label: "Tab 2",
        targetUrl: "/pageHeader",
        tabContentId: "Tab62",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav63-tab",
        name: "Tab63",
        tabContentData: "Tab content data for Tab3",
        label: "Tab 3",
        targetUrl: "/pageHeader",
        tabContentId: "Tab63",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav64-tab",
        name: "Tab64",
        tabContentData: "Tab content data for Tab4",
        label: "Tab 4",
        targetUrl: "/pageHeader",
        tabContentId: "Tab64",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav65-tab",
        name: "Tab65",
        tabContentData: "Tab content data for Tab5",
        label: "Tab 5",
        targetUrl: "/pageHeader",
        tabContentId: "Tab65",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav66-tab",
        name: "Tab66",
        tabContentData: "Tab content data for Tab6",
        label: "Tab 6",
        targetUrl: "/pageHeader",
        tabContentId: "Tab66",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav67-tab",
        name: "Tab67",
        tabContentData: "Tab content data for Tab7",
        label: "Tab 7",
        targetUrl: "/pageHeader",
        tabContentId: "Tab67",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav68-tab",
        name: "Tab68",
        tabContentData: "Tab content data for Tab8",
        label: "Tab 8",
        targetUrl: "/pageHeader",
        tabContentId: "Tab68",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav69-tab",
        name: "Tab69",
        tabContentData: "Tab content data for Tab9",
        label: "Tab 9",
        targetUrl: "/pageHeader",
        tabContentId: "Tab69",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav610-tab",
        name: "Tab610",
        tabContentData: "Tab content data for Tab10",
        label: "Tab 10",
        targetUrl: "/pageHeader",
        tabContentId: "Tab610",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav611-tab",
        name: "Tab611",
        tabContentData: "Tab content data for Tab11",
        label: "Tab 11",
        targetUrl: "/pageHeader",
        tabContentId: "Tab611",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav612-tab",
        name: "Tab612",
        tabContentData: "Tab content data for Tab12",
        label: "Tab 12",
        targetUrl: "/pageHeader",
        tabContentId: "Tab612",
        isActive: false,
        isDisabled: false
      }
    ];
    this.simplifiedTabItemsWithoutSwipe = [
      {
        id: "nav71-tab",
        name: "Tab71",
        tabContentData: "Tab content data for Tab1",
        label: "Tab 1",
        targetUrl: "/pageHeader",
        tabContentId: "Tab71",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav72-tab",
        name: "Tab72",
        tabContentData: "Tab content data for Tab2",
        label: "Tab 2",
        targetUrl: "/pageHeader",
        tabContentId: "Tab72",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav73-tab",
        name: "Tab73",
        tabContentData: "Tab content data for Tab3",
        label: "Tab 3",
        targetUrl: "/pageHeader",
        tabContentId: "Tab73",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav74-tab",
        name: "Tab74",
        tabContentData: "Tab content data for Tab4",
        label: "Tab 4",
        targetUrl: "/pageHeader",
        tabContentId: "Tab74",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav75-tab",
        name: "Tab75",
        tabContentData: "Tab content data for Tab5",
        label: "Tab 5",
        targetUrl: "/pageHeader",
        tabContentId: "Tab75",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav76-tab",
        name: "Tab76",
        tabContentData: "Tab content data for Tab6",
        label: "Tab 6",
        targetUrl: "/pageHeader",
        tabContentId: "Tab76",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav77-tab",
        name: "Tab77",
        tabContentData: "Tab content data for Tab7",
        label: "Tab 7",
        targetUrl: "/pageHeader",
        tabContentId: "Tab77",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav78-tab",
        name: "Tab78",
        tabContentData: "Tab content data for Tab8",
        label: "Tab 8",
        targetUrl: "/pageHeader",
        tabContentId: "Tab78",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav79-tab",
        name: "Tab79",
        tabContentData: "Tab content data for Tab9",
        label: "Tab 9",
        targetUrl: "/pageHeader",
        tabContentId: "Tab79",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav710-tab",
        name: "Tab710",
        tabContentData: "Tab content data for Tab10",
        label: "Tab 10",
        targetUrl: "/pageHeader",
        tabContentId: "Tab710",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav711-tab",
        name: "Tab711",
        tabContentData: "Tab content data for Tab11",
        label: "Tab 11",
        targetUrl: "/pageHeader",
        tabContentId: "Tab711",
        isActive: false,
        isDisabled: false
      },
      {
        id: "nav712-tab",
        name: "Tab712",
        tabContentData: "Tab content data for Tab12",
        label: "Tab 12",
        targetUrl: "/pageHeader",
        tabContentId: "Tab712",
        isActive: false,
        isDisabled: false
      }
    ];
    this.activatedRoute.queryParams.subscribe(res => {
      if (res['tabId'] && res['activeTab']) {
        if ((res['tabId'] == 'TabsContainer1') || (res['tabId'] == 'TabsContainer2') ||(res['tabId'] == 'TabsContainer3')
            ||(res['tabId'] == 'TabsContainer4')||(res['tabId'] == 'TabsContainer5') ||(res['tabId'] == 'TabsContainer6') ||(res['tabId'] == 'TabsContainer7')) {
          this.activeTab = res['activeTab'];
        }
      }
      else {
        this.activeTab = "";
      }
    });
  }

  switchPadding() {
    this.sliderBtns = !this.sliderBtns;
  }

  onHierarchyTabClick(event: TabClickEvent): void {
    this.hierarchyTabItems = this.hierarchyTabItems
      .slice(0, event.tabIndex + 1)
      .map((tab, index) => ({ ...tab, isActive: index === event.tabIndex }));
    this.activeHierarchyTab = event.tab.tabContentId;
  }

  openHierarchyChild(tabIndex: number): void {
    const childTab = this.hierarchyTabLevels[tabIndex + 1];
    if (!childTab) {
      return;
    }
    this.hierarchyTabItems = [
      ...this.hierarchyTabItems
        .slice(0, tabIndex + 1)
        .map(tab => ({ ...tab, isActive: false })),
      { ...childTab, isActive: true }
    ];
    this.activeHierarchyTab = childTab.tabContentId;
  }
}
